import type { Event } from '@sentry/vue';

/**
 * Vue 내부 런타임 오류 키워드 목록
 * 컴포넌트 unmount 타이밍 이슈로 발생하며 사용자 체감 영향 없음
 */
const VUE_RUNTIME_ERROR_KEYWORDS = [
    '__vnode',
    'parentNode',
    'nextSibling',
    'emitsOptions',
    'shapeFlag',
    'insertBefore',
    "'type' of 'vnode'",
    'unmountComponent',
    'locateNonHydratedAsyncRoot',
    '__isMounted',
];

/**
 * Vue 내부 런타임(vnode/DOM) 오류인지 판별
 * culprit가 deps/chunk-* 이고 에러 메시지가 Vue 런타임 키워드를 포함하면 true
 */
export function isVueRuntimeError(event: Event): boolean {
    const culprit = (event as any).culprit || '';
    if (!/deps\/chunk-/.test(culprit)) {
        return false;
    }

    return (
        event.exception?.values?.some((ex) =>
            VUE_RUNTIME_ERROR_KEYWORDS.some((keyword) => ex.value?.includes(keyword)),
        ) ?? false
    );
}

/**
 * Inertia.js 내부 오류 키워드 목록
 * 라이브러리 내부 history.state 접근 및 직렬화 이슈로 발생하며 사용자 체감 영향 없음
 */
const INERTIA_INTERNAL_ERROR_KEYWORDS = ['scrollRegions', 'window.history.state.page', 'DataCloneError'];

/**
 * Inertia.js 내부 오류인지 판별
 * history.state null 접근, replaceState 직렬화 실패 등 라이브러리 내부 이슈
 */
export function isInertiaInternalError(event: Event): boolean {
    return (
        event.exception?.values?.some((ex) =>
            INERTIA_INTERNAL_ERROR_KEYWORDS.some(
                (keyword) => ex.value?.includes(keyword) || ex.type?.includes(keyword),
            ),
        ) ?? false
    );
}
